import { render, staticRenderFns } from "./AdditClass.vue?vue&type=template&id=5644d0eb&"
import script from "./AdditClass.vue?vue&type=script&lang=js&"
export * from "./AdditClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports